import { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import AppTopbar from './AppTopbar';
import AppFooter from './AppFooter';
import AppConfig from './AppConfig';
import AppSearch from './AppSearch';
import AppBreadcrumb from './AppBreadcrumb';
import useAuth from "../src/hooks/useAuth";

import { Dashboard } from './components/dashbord';
import PrimeReact from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';
import './AppCelebration.css';


import { ClientContactPerson } from './components/clientContactPerson';
import { ClientLead } from './components/clientLead';
import { UserMast } from './components/userMast';
import { CompanyMast } from './components/companyMast';
import { BranchMast } from './components/branchMast';
import { IpConfig } from './components/ipConfig';
import { VendorCompanyMast } from './components/vendorCompanyMast';
import { UserProfile } from './components/userProfile';
import { SalesRequirementMast } from './components/requirement/sales';
import { RecruiterRequirementMast } from './components/requirement/recruiter';
import { PipelineMast } from './components/pipeline';
import { PageMast } from './components/pageMast';
import { RoleMast } from './components/roleMast';
import { ECI } from './components/eci';
import { ClientTransfer } from './components/clientTransfer';
import { SignatureMast } from './components/signatureMast';
import { EmailTemplate } from './components/emailTemplate';
import { WebsiteTemplate } from './components/websiteTemplate';
import { EndClientMast } from './components/endClient';
import { IndustryMast } from './components/industry';
import { MajorTech } from './components/MajorTechnology';
import { ShowPurchaseOrder } from './components/showPurchaseOrder';
import { EmpDlts } from './components/showEmpDetails';
import { TicketMast } from './components/ticket';
import { VotingQuestions } from './components/votingQuestion';
import { SalesEfficiency, RecruiterEfficiency, SalesReport, RecruiterReport, AllocationHistory, SkillsUserReport, FloatSalesReport, FloatSalesEfficiency, BranchLatency } from './components/reports';
import { BenchConsultant } from './components/benchConsultant';
import { TeamManagement } from './components/teamManagement';
import { Places } from './components/places';
import { Employee } from './components/employee';
import { Source } from './components/source';
import { Designation } from './components/designation';
import { Visa } from './components/visa';
import { Process } from './components/process';
import { ClientTransferSetting } from './components/clientTransferSetting';
import { ClientTransferProgressSetting } from './components/clientTransferProgressSetting';
import { AddRequirementType } from './components/clientCategory';
import { AddNotice } from './components/addNotice';
import { PrimeVendorPerformanceReports } from './components/primeVendorPerformanceReports';
import { ShowTimesheet } from './components/showTimesheet';
import { LoginHistory } from './components/loginHistory';
import { SubVendorPerformanceReports } from './components/subVendorPerformanceReports';
import { DataCorrection } from './components/dataCorrection';
import { AttendanceMark } from './components/attendanceMark';
import { SalesAllocation } from './components/salesAllocation';
import { NonPerformingVendor } from './components/nonPerformingVendor';
import { Company } from './components/dashbord/Company';
import { Branch } from './components/dashbord/Branch';
import { NonPerformingPvAllocation } from './components/nonPerformingPvAllocation';
import { PocTransferReq } from './components/pocTransferReq';
//import { ScheduleSetting } from './components/schedule_Settings/ScheduleSettingsTemplate';
import { TargetTemplate } from './components/target';
import { SkillTeamManagement } from './components/skillTeamsManagement';
import { TargetHistory } from './components/reports/targetSales/Table';
import { TargetRecruiterHistory } from './components/reports/targetRecruiter/Table';
import { Float } from './components/float';
import { SkillReport } from './components/reports/skillReport';
import { TopView } from './components/topView/TopView';
import { SkillRecruiterWiseReport } from './components/reports/skillRecruiterWiseReport/Table';
import { SkillBranchWiseReport } from './components/reports/skillRecruiterBranchReport';
import { ReqForRateApprove } from './components/reqForRateApprove';
// import { EnableModule } from './components/enableModule';
import { SpecialConstraintApprove } from './components/specialConstraintApproval';
import { SkillMastHistory } from './components/skillMastHistory/SkillMastHistory';
import { PipelineStatus } from './components/pipelineStatus';
import { RecruiterRejectedReqMast } from './components/RecruiterRejectedReq';
import { TestingEmailSetting } from './components/testingEmailSetting';
// import { PrimeVendorRatingSetting } from './components/ratingModule';
// import { PrimeVendorProgressSetting } from './components/primeVendorProgressSetting';
import { TeamMemberList } from './components/teamMemberList';
import { BlackListStatus } from './components/blackListStatus';
import { BlackListMast } from './components/blackListMast';
import { AllocationList } from './components/allocationsList';
import { Gallery } from './components/Gallery';
import { OutLookEmails } from './components/outLookEmails';
import { VideoMast } from './components/videoMast';
import { FindResumes } from './components/findResumes';
import { InvoiceTracking } from './components/invoiceTracking';
import { MarqueeView } from './components/TopMarquee/Marquee';
import { RequirementFloat } from './components/RecruiterFloatReq';
import { AllPrimeVendorPerformanceReports } from './components/allPrimeVendorReport';
import { AllSubVendorPerformanceReports } from './components/AllSubVendorReports';
import { ImageGallery } from './components/imageGallery';
import ConfettiExplosion from 'react-confetti-explosion';
import { Dialog } from "primereact/dialog";
import celeEmogi from "./assets/branchRanking/celeEmogi.png";
import JobvrittaVideo from "./assets/flags/JobvrittaPortal.mp4";
import { BenchRequirement } from './components/requirement/benchRequirement';
import { PO_Incentive_Distribution } from './components/poIncDistribution';
import { ExternalUserMast } from './components/externalUserMast';
import { Remitance } from './components/remitance';
import { Invoices } from './components/invoices';
import { WorkInProgressReports } from './components/reports/workInProgress';
import { Assignments } from './components/Assignments';
import { AssignmentMast } from './components/AssignmentMast';
import { Company_DocumentMast } from './components/companyDocument';
import { SpecialClauseMast } from './components/specialClauseMast/SpecialClauseMast';
import { TimeSheetReport } from './components/reports/timesheetReport/Table';
import { SubvendorTimeSheetReport } from './components/timeSheetReport';
import { ConsultantTimeSheetReport } from './components/timeSheetReport/pendingConsultant/Table';
import { NewPage } from './components/newPageMast';
import { RoleMast as NewRoleMast } from './components/newRoleMast';
import { SubVendorInvoices } from './components/subVendorInvoices';
import { CallingExtension } from './components/callingExtension';
import { IVRsUserList } from './components/ivRUsersList';
import { CallingHistory } from './components/callingHistory';
import { Docs } from './components/docs';
import { Incentives } from './components/incentives';
import { PrimeVendorInvoice } from './components/reports/primeVendorInvoice';
// import { DemoTable } from './components/demoTable';
import { UserLeads } from './components/userLeads';
// import { IncentiveSetting } from './components/incentiveSetting';
import { ConsultantHotList } from './components/consultantHotList';
import { IncentiveSetting } from './components/incentiveSetting';
import { BranchIncentive } from './components/branchIncentive';
import { GeneratedBranchImvoice } from './components/branchIncentive/GeneratedBranchImvoice';
import { PendingPaymentInvoices } from './components/pendingPaymentInvoices/PendingPaymentInvoices';
import { InActivePOCReport } from './components/reports/inActivePOC';
import { InActivePVReport } from './components/reports/inActivePV';
import { FollowUpPoc } from './components/followUpPoc';
import { CalculatedInvoiceIncentive } from './components/calculatedInvoiceIncentiveList/CalculatedInvoiceIncentive';
//import { AllConsultant } from './components/allConsultant';
//import { SearchConsultant } from './components/searchConsultant/SearchConsultant';
import { PendingInvoicesCompanyWise } from './components/showPurchaseOrder/PendingInvoicesCompanyWise';
import { BranchInvoiceListByConsultant } from './components/branchInvoiceListByConsultant';
import { GenerateBranchInvoiceTable } from './components/branchInvoiceListByConsultant/GenerateBranchInvoiceTable';
import { QualityControle } from './components/qualityControle';
import { ReleasedIncentiveList } from './components/incentives/ReleasedIncentiveList';
import { UserwiseLatency } from './components/reports/userWiseLatency/Table';
import { LeagalDocument } from './components/leagalDocument/LeagalDocument';
import { ClauseMaster } from './components/leagalDocument/ClauseMaster';
import { HierarchyList } from './components/showPurchaseOrder/HierarchyList';
import { NonPerformingPvReport } from './components/reports/nonPerformingPVReport/Table';
import { ResumeSearchConsultant } from './components/resumeSearchConsultant';
import { ActiveTimeSheetReport } from './components/reports/activeTimesheetReport/Table';
// import { ReleaseInvoicePayment } from './components/releaseInvoicePayment';
// import { SubVendorInvoices } from './components/subVendorInvoices';
//import { SubmissionTableMy } from './components/submissionForApproval';
import { Inbox } from './components/email';
import { TimesheetList } from './components/timesheetList';
import { AllocateTeamMast } from './components/allocateTeamMast/AllocateTeamMast';
//import { MirrorPageSetting } from './components/mirrorPageSetting';
import { TrainingCategory } from './components/carnivalTraining/trainingMasters/trainingCategory/TrainingCategory';
import { TrainingTopics } from './components/carnivalTraining/trainingMasters/trainingTopics/TrainingTopics';
import { TrainnerSelectionModule } from './components/carnivalTraining/trainingMasters/trainnerSelectionModule/TrainnerSelectionModule';
import { TrainingFormSubmission } from './components/carnivalTraining/trainingFormSubmission/TrainingFormSubmission';
import { TrainingScheduler } from './components/carnivalTraining/trainingScheduler/TrainingScheduler';
import { TrainingQuestions } from './components/carnivalTraining/trainingMasters/trainingQuestions';
import { TrainingRatingForm } from './components/carnivalTraining/trainingRatingForm';
import { TrainingRatings } from './components/carnivalTraining/trainingRatings';
import Support from './components/support';
import { BranchInvoicePercentageMatrix } from './components/branchInvoicePercentageMatrix';
import { UserCallingHistory } from './components/UserCallingHistory';
import { LegalDocumentsList } from './components/legalDocumentsList';
import { TimesheetSetting } from './components/timesheetSetting';
import { DateSetting } from './components/dateSetting';
// import { DemoTable } from './components/demoTable';
import { VendorCompanyAccounts } from './components/vendorCompanyAccounts';
import { MassMail } from './components/massMail';
import MassMailSetting from './components/massMailSetting/MassMailSetting';
import MassMailHistory from './components/massMailHistory/MassMailHistory';
import { ReqPublishSetting } from './components/reqPublishSetting';
import ExternalSearchConsultant from './components/externalSearchConsultant/ExternalSearchConsultant';
import PoRateAproval from './components/poRateApproval/PoRateAproval';
//import { TimesheetReportByUserType } from './components/reports/timesheetReport/TimesheetReportByUserType';
import USAccountReport from './components/reports/us_Account_Report/US_Account_Report';
import CompanyGrouping from './components/companyGrouping/CompanyGrouping';
import DiceSetting from './components/externalSearchConsultant/dice/diceSetting/DiceSetting';
import MonsterSetting from './components/externalSearchConsultant/monsterSetting/MonsterSetting';
import BranchAllocationSetting from './components/branchAllocationSetting/BranchAllocationSetting';
import ApwDocumentMast from './components/apwDocumentMast/ApwDocumentMast';
import { AdminSetting } from './components/externalSearchConsultant/monsterSetting/AdminSetting';
import PrimeVendorAllocation from './components/primeVendorAllocation/PrimeVendorAllocation';
import { LegalTeamManagement } from './components/legalTeamManagment';
import LegalTaskManagement from './components/legalTaskManagement/LegalTaskManagement';
import ConsutantMaster from './components/consultant_Master/ConsutantMaster';
import FloatQuestionnaireMast from './components/floatQuestionnaireMast/FloatQuestionnaireMast';
import { LegalTaskType } from './components/legalTaskType';
import TenderClientCategory from './components/tender/tenderClientCategory/TenderClientCategory';
import { TenderClientMast } from './components/tender/tender_Client_Mast';
import { TenderClientPOC } from './components/tender/tender_Client_POC';
import { TenderMast } from './components/tender/tender_Mast';
import { TenderTeamManagementt } from './components/tender/tenderTeamManagement';
import WorkStreamCategories from './components/tender/workStreamCategories/WorkStreamCategories';
import WorkStreamList from './components/tender/workStreamList/WorkStreamList';
// import { Demo } from './components/demo';
import TenderServiceDepartmentMast from './components/tender/tenderServiceDepartmentMast/TenderServiceDepartmentMast';
import { RPFBidTeamManagement } from './components/tender/rfp_Bid_TeamManagement/RFP_Bid_TeamManagement';
import RFPProposalTeamManagement from './components/tender/rfp_Proposal_Team_Management/RFP_Proposal_Team_Management';
import RFPPOCDepartmentMast from './components/tender/rfp_POC_Department_Mast/RFPPOCDepartmentMast';
import { RevenueReportUserWise } from './components/reports/revenueReport/userWise';
import { RevenueReportBranchWise } from './components/reports/revenueReport/branchWise';
import US_Account_Created_Report from './components/reports/us_Account_Created_Report/US_Account_Created_Report';
import RFPWorkstreamMasterDocuments from './components/tender/rfp_Workstream_Master_Documents/RFP_Workstream_Master_Documents';
import { RevenueReportSalesHead } from './components/reports/revenueReport/salesHeadWise';
import { RevenueReportRecruiterHead } from './components/reports/revenueReport/recruiterHeadWise';
import { StatusMaster } from './components/poEscalation/statusMaster';
import { TypeMaster } from './components/poEscalation/typeMaster';
import { EscalationMaster } from './components/poEscalation/escalationMaster';
import { LeadScrappingJobs } from './components/leadScrappings/leadScrappingJobs/LeadScrappingJobs';
import { LeadScrappingSetting } from './components/leadScrappings/leadScrappingSetting/LeadScrappingSetting';
// import CreatedTimesheetsReport from './components/reports/created_Timesheets_Report/CreatedTimesheetsReport';
// import { CreativityDashboard } from './components/creativityDashboard';

const App = () => {
    const [menuActive, setMenuActive] = useState(false);
    const [menuMode, setMenuMode] = useState('slim');

    const celeb = JSON.parse(localStorage.getItem('celeb'));
    const showVideo = JSON.parse(localStorage.getItem('showVideo'));


    const [colorScheme, setColorScheme] = useState('light');
    const [menuTheme, setMenuTheme] = useState('layout-sidebar-darkgray');
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [searchActive, setSearchActive] = useState(false);
    const [topbarUserMenuActive, setTopbarUserMenuActive] = useState(false);
    const [topbarNotificationMenuActive, setTopbarNotificationMenuActive] = useState(false);
    const [rightMenuActive, setRightMenuActive] = useState(false);
    const [configActive, setConfigActive] = useState(false);
    const [inputStyle, setInputStyle] = useState('outlined');
    const [ripple, setRipple] = useState(false);
    const [logoColor, setLogoColor] = useState('white');
    const [componentTheme, setComponentTheme] = useState('blue');
    const [logoUrl, setLogoUrl] = useState('assets/layout/images/logo-dark.svg');
    const [celebration, setCelebration] = useState((celeb !== null && celeb.view === true) ? true : false);
    const [celebrationModal, setCelebrationModal] = useState((celeb !== null && celeb.view === true) ? true : false);
    const [videoModal, setVideoModal] = useState((showVideo !== null && showVideo.view === true) ? true : false);
    // const [celebrationModal, setCelebrationModal] = useState((celeb !== null && celeb.view === true) ? true : false);

    const copyTooltipRef = useRef();
    const location = useLocation();
    const { loginObj, hasPermission } = useAuth();

    let menuClick = false;
    let searchClick = false;
    let userMenuClick = false;
    let notificationMenuClick = false;
    let rightMenuClick = false;
    let configClick = false;
    const _roles = [];

    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const pages = new Map();
    loginObj.page.forEach(element => {
        if (element.is_View > 0 || element.is_Create > 0 || element.is_Update > 0 || element.is_Export > 0)
            pages.set(element.pageURL, {
                is_Create: element.is_Create > 0,
                is_Delete: element.is_Delete > 0,
                is_Update: element.is_Update > 0,
                is_Export: element.is_Export > 0,
                is_View: element.is_View > 0
            });
    });

    // console.log(loginObj);

    const breadcrumb = [
        { path: '/dashboard', parent: 'Dashboard', label: 'Dashboard' },
        { path: '/login', parent: 'Login', label: 'Login' },
        { path: '/profile', parent: 'Profile', label: 'Profile' }
    ];

    const menu = [
        {
            label: 'Dashboard',
            icon: 'pi pi-fw pi-home',
            items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/dashboard' }]
        },
        { separator: true },
        {
            label: 'Requirement',
            icon: 'pi pi-fw pi-table',
            items: []
        },
        { separator: true },
        {
            label: 'Masters',
            icon: 'pi pi-briefcase',
            items: []
        },
        { separator: true },
        {
            label: 'Reports',
            icon: 'pi pi-chart-bar',
            items: []
        },
        // { separator: true },
        // {
        //     label: 'Timesheets Reports',
        //     icon: 'pi pi-slack',
        //     items: []
        // },
        { separator: true },
        {
            label: 'Settings',
            icon: 'pi pi-cog',
            items: []
        },
        { separator: true },
        {
            label: 'Modules',
            icon: 'pi pi-table',
            items: []
        },
        { separator: true },
        {
            label: 'Allocation',
            icon: 'pi pi-slack',
            items: []
        },
        { separator: true },
        {
            label: 'Invoices',
            icon: 'pi pi-book',
            items: []
        },
        { separator: true },
        {
            label: 'Candidate Search',
            icon: 'pi pi-search',
            items: []
        },
        { separator: true },
        {
            label: 'Training',
            icon: 'pi pi-paperclip',
            items: []
        },
        { separator: true },
        {
            label: 'Support',
            icon: 'pi pi-ticket',
            items: []
        },
        { separator: true },
        {
            label: 'RFP',
            icon: 'pi pi-ticket',
            items: []
        },

    ];


    loginObj.page.forEach(element => {

        if (element.is_View > 0 || element.is_Create > 0 || element.is_Update > 0) {
            if (element.pageURL === "eciScheduleNotify" || element.pageURL === "pocTransferReqNotify" || element.pageURL === "reqRateApproveNotify" || element.pageURL === "specialConstraintsReqNotify" || element.pageURL === "floatRequirementNotification" || element.pageURL === "timesheetAddedCount") {
            } else if (element.pageURL === 'email' || element.pageURL === "companydashboard" || element.pageURL === "branchdashboard" || element.pageURL === "videoMast") {
                let _objb = {
                    path: "/" + element.pageURL,
                    parent: 'Dashboard',
                    label: element.pageName
                }
                breadcrumb.push(_objb);
                let _objm = {
                    label: element.pageName,
                    icon: 'pi pi-fw pi-circle',
                    to: "/" + element.pageURL
                }
                menu[0].items.push(_objm);
            } else if (element.pageURL === "salesReport" || element.pageURL === "salesEfficiency" || element.pageURL === "recruiterReport" || element.pageURL === "recruiterEfficiency" || element.pageURL === "primeVendorPerformanceReports" || element.pageURL === "subVendorPerformanceReports" || element.pageURL === "targetReportSales" || element.pageURL === "targetReportRecruiters" || element.pageURL === "skillReport" || element.pageURL === "skillsUserReport" || element.pageURL === "skillReportUserWiseRecruiter" || element.pageURL === "skillBranchWiseReport" || element.pageURL === "allPrimeVendorPerformanceReports" || element.pageURL === "allSubVendorPerformanceReports" || element.pageURL === "activeClientPerformance" || element.pageURL === "timeSheetReport" || element.pageURL === "subvendorTimeSheetReport" || element.pageURL === "consultantTimeSheetReport" || element.pageURL === "primeVendorInvoiceReport" || element.pageURL === "userwiseLatency" || element.pageURL === "branchLatency" || element.pageURL === "nonPerformingPvReport" || element.pageURL === "activeTimeSheetReport" || element.pageURL === "usAccountReports" || element.pageURL === "revenueReportUserWise" || element.pageURL === "revenueReportBranchWise" || element.pageURL === "createdTimesheetsReport" || element.pageURL === "revenueReportSalesHead" || element.pageURL === "revenueReportRecruiterHead") {
                let _objb = {
                    path: "/" + element.pageURL,
                    parent: 'Reports',
                    label: element.pageName
                }
                breadcrumb.push(_objb);
                let _objm = {
                    label: element.pageName,
                    icon: 'pi pi-fw pi-circle',
                    to: "/" + element.pageURL
                }
                menu[6].items.push(_objm);
            } else if (element.pageURL === "branch" || element.pageURL === "clientCompany" || element.pageURL === "clientContactPerson" || element.pageURL === "clientLead" || element.pageURL === "company" || element.pageURL === "endClient" || element.pageURL === "majorTek" || element.pageURL === "companyDocument" || element.pageURL === "callingExtension" || element.pageURL === "docs" || element.pageURL === "vendorCompanyAccounts" || element.pageURL === "companyGrouping" || element.pageURL === "consutantMaster") {
                let _objb = {
                    path: "/" + element.pageURL,
                    parent: 'Masters',
                    label: element.pageName
                }
                breadcrumb.push(_objb);
                let _objm = {
                    label: element.pageName,
                    icon: 'pi pi-fw pi-circle',
                    to: "/" + element.pageURL
                }
                menu[4].items.push(_objm);
            }
            else if (element.pageURL === "users" || element.pageURL === "signature" || element.pageURL === "emailTemplate" || element.pageURL === "industry" || element.pageURL === "ipConfig" || element.pageURL === "majorTek" || element.pageURL === "pages" || element.pageURL === "roles" || element.pageURL === "website" || element.pageURL === "pipelineStatus" || element.pageURL === "testingEmailSetting" || element.pageURL === "blackListMast" || element.pageURL === "blackListStatus" || element.pageURL === "dateSetting" || element.pageURL === 'reqPublishSetting' || element.pageURL === "branchAllocationSetting") {
                let _objb = {
                    path: "/" + element.pageURL,
                    parent: 'Settings',
                    label: element.pageName
                }
                breadcrumb.push(_objb);
                let _objm = {
                    label: element.pageName,
                    icon: 'pi pi-fw pi-circle',
                    to: "/" + element.pageURL
                }
                menu[8].items.push(_objm);
            }

            else if (element.pageURL === "allocationHistory" || element.pageURL === "salesAllocation" || element.pageURL === "nonPerformingVendor" || element.pageURL === "allocationList") {
                let _objb = {
                    path: "/" + element.pageURL,
                    parent: 'Allocation',
                    label: element.pageName
                }
                breadcrumb.push(_objb);
                let _objm = {
                    label: element.pageName,
                    icon: 'pi pi-fw pi-circle',
                    to: "/" + element.pageURL
                }
                menu[12].items.push(_objm);
            }
            // else if (element.pageURL === "timeSheetReport" || element.pageURL === "subvendorTimeSheetReport" || element.pageURL === "consultantTimeSheetReport") {
            //     let _objb = {
            //         path: "/" + element.pageURL,
            //         parent: 'Timesheets Reports',
            //         label: element.pageName
            //     }
            //     breadcrumb.push(_objb);
            //     let _objm = {
            //         label: element.pageName,
            //         icon: 'pi pi-fw pi-circle',
            //         to: "/" + element.pageURL
            //     }
            //     menu[8].items.push(_objm);
            // }


            else if (element.pageURL === "recruiterAllRequirement" || element.pageURL === 'publishedRequirement' || element.pageURL === "salesAllRequirement" || element.pageURL === "salesMyRequirement" || element.pageURL === "recruiterMyRequirement" || element.pageURL === "eci" || element.pageURL === "showPipeline" || element.pageURL === "majorTechAllocation" || element.pageURL === "pocTransferReq" || element.pageURL === "float" || element.pageURL === "reqForRateApprove" || element.pageURL === "specialConstraintApprove" || element.pageURL === "recruiterRejectedReqMast" || element.pageURL === "requirementFloat" || element.pageURL === "benchRequirement") {
                if (_roles.includes(19) && element.pageURL === "eci") {
                    if (loginObj.id === 3717) {
                        if (element.pageURL === "majorTechAllocation") {
                            if (loginObj.is_Assign_Major_Tek === true) {
                                let _objb = {
                                    path: "/" + element.pageURL,
                                    parent: 'Requirement',
                                    label: element.pageName
                                }
                                breadcrumb.push(_objb);
                                let _objm = {
                                    label: element.pageName,
                                    icon: 'pi pi-fw pi-circle',
                                    to: "/" + element.pageURL
                                }
                                menu[2].items.push(_objm);
                            }
                        } else {
                            let _objb = {
                                path: "/" + element.pageURL,
                                parent: 'Requirement',
                                label: element.pageName
                            }
                            breadcrumb.push(_objb);
                            let _objm = {
                                label: element.pageName,
                                icon: 'pi pi-fw pi-circle',
                                to: "/" + element.pageURL
                            }
                            menu[2].items.push(_objm);
                        }
                    }
                } else {
                    if (element.pageURL === "majorTechAllocation") {
                        if (loginObj.is_Assign_Major_Tek === true) {
                            let _objb = {
                                path: "/" + element.pageURL,
                                parent: 'Requirement',
                                label: element.pageName
                            }
                            breadcrumb.push(_objb);
                            let _objm = {
                                label: element.pageName,
                                icon: 'pi pi-fw pi-circle',
                                to: "/" + element.pageURL
                            }
                            menu[2].items.push(_objm);
                        }
                    }
                    else if ((element.pageURL === "salesAllRequirement" || element.pageURL === "salesMyRequirement") && !_roles.includes(3)) {
                        let _objb = {
                            path: "/" + element.pageURL,
                            parent: 'Requirement',
                            label: element.pageName
                        }
                        breadcrumb.push(_objb);
                        let _objm = {
                            label: element.pageName,
                            icon: 'pi pi-fw pi-circle',
                            to: "/" + element.pageURL
                        }
                        menu[2].items.push(_objm);
                    }
                    else {
                        let _objb = {
                            path: "/" + element.pageURL,
                            parent: 'Requirement',
                            label: element.pageName
                        }
                        breadcrumb.push(_objb);
                        let _objm = {
                            label: element.pageName,
                            icon: 'pi pi-fw pi-circle',
                            to: "/" + element.pageURL
                        }
                        menu[2].items.push(_objm);
                    }
                }
            }
            else if (element.pageURL === "invoices" || element.pageURL === "incentive" || element.pageURL === "incentiveSetting" || element.pageURL === "pendingPaymentInvoices" || element.pageURL === "generatedBranchImvoice" || element.pageURL === "branchIncentive" || element.pageURL === "calculatedInvoiceIncentive" || element.pageURL === "subVendorInvoices" || element.pageURL === "paymentUpdateSVInvoices" || element.pageURL === "pendingInvoicesCompanyWise" || element.pageURL === "branchInvoiceListByConsultant" || element.pageURL === "generateBranchInvoiceTable" || element.pageURL === "releasedIncentiveList" || element.pageURL === "branchInvoicePercentageMatrix") {
                if (element.pageURL === "branchInvoiceListByConsultant") {
                    if (loginObj.id === 4212) {
                        let _objb = {
                            path: "/" + element.pageURL,
                            parent: 'Invoices',
                            label: element.pageName
                        }
                        breadcrumb.push(_objb);
                        let _objm = {
                            label: element.pageName,
                            icon: 'pi pi-fw pi-circle',
                            to: "/" + element.pageURL
                        }
                        menu[14].items.push(_objm);
                    } else if (!_roles.includes(38)) {
                        let _objb = {
                            path: "/" + element.pageURL,
                            parent: 'Invoices',
                            label: element.pageName
                        }
                        breadcrumb.push(_objb);
                        let _objm = {
                            label: element.pageName,
                            icon: 'pi pi-fw pi-circle',
                            to: "/" + element.pageURL
                        }
                        menu[14].items.push(_objm);
                    }
                } else {
                    let _objb = {
                        path: "/" + element.pageURL,
                        parent: 'Invoices',
                        label: element.pageName
                    }
                    breadcrumb.push(_objb);
                    let _objm = {
                        label: element.pageName,
                        icon: 'pi pi-fw pi-circle',
                        to: "/" + element.pageURL
                    }
                    menu[14].items.push(_objm);
                }
            } else if (element.pageURL === "trainingCategory" || element.pageURL === "trainingTopics" || element.pageURL === "trainingTrainners" || element.pageURL === "trainingForms" || element.pageURL === "trainingSchedules" || element.pageURL === "trainingQuestions" || element.pageURL === "trainingRatingForm" || element.pageURL === "trainingRatings") {
                let _objb = {
                    path: "/" + element.pageURL,
                    parent: 'Training',
                    label: element.pageName
                }
                breadcrumb.push(_objb);
                let _objm = {
                    label: element.pageName,
                    icon: 'pi pi-fw pi-circle',
                    to: "/" + element.pageURL
                }
                menu[16].items.push(_objm);
            } else if (element.pageURL === "support") {
                let _objb = {
                    path: "/" + element.pageURL,
                    parent: 'Support',
                    label: element.pageName
                }
                breadcrumb.push(_objb);
                let _objm = {
                    label: element.pageName,
                    icon: 'pi pi-ticket',
                    to: "/" + element.pageURL
                }
                menu[18].items.push(_objm);
            } else if (element.pageURL === "tenderClientCategory" || element.pageURL === "tenderClientMast" || element.pageURL === "tenderClientPOC" || element.pageURL === "tenderMast" || element.pageURL === "tenderTeamManagementt" || element.pageURL === "tenderworkStreamCategories" || element.pageURL === "tenderworkStreamList" || element.pageURL === "tenderServiceDepartmentMast" || element.pageURL === "rfpBidTeamManagement" || element.pageURL === "rfpProposalTeamManagement" || element.pageURL === "pocDepartmentMast") {
                let _objb = {
                    path: "/" + element.pageURL,
                    parent: 'RFP',
                    label: element.pageName
                }
                breadcrumb.push(_objb);
                let _objm = {
                    label: element.pageName,
                    icon: 'pi pi-fw pi-circle',
                    to: "/" + element.pageURL
                }
                menu[22].items.push(_objm);
            } else {
                if (element.pageURL === "skillTeamManagement") {
                    if ((loginObj.is_Team_Lead == true && _roles.includes(3))) {
                        let _objb = {
                            path: "/" + element.pageURL,
                            parent: 'Modules',
                            label: element.pageName
                        }
                        breadcrumb.push(_objb);
                        let _objm = {
                            label: element.pageName,
                            icon: 'pi pi-fw pi-circle',
                            to: "/" + element.pageURL
                        }
                        menu[10].items.push(_objm);
                    }
                }
                if (element.pageURL === "skillTeamManagement") {
                    if (!_roles.includes(3)) {
                        let _objb = {
                            path: "/" + element.pageURL,
                            parent: 'Modules',
                            label: element.pageName
                        }
                        breadcrumb.push(_objb);
                        let _objm = {
                            label: element.pageName,
                            icon: 'pi pi-fw pi-circle',
                            to: "/" + element.pageURL
                        }
                        menu[10].items.push(_objm);
                    }
                } else if (element.pageURL === "diceSetting" || element.pageURL === "monsterSetting" || element.pageURL === "externalSearchConsultant" || element.pageURL === "resumeSearchConsultant" || element.pageURL === "adminSetting") {
                    let _objb = {
                        path: "/" + element.pageURL,
                        parent: 'Candidate Search',
                        label: element.pageName
                    }
                    breadcrumb.push(_objb);
                    let _objm = {
                        label: element.pageName,
                        icon: 'pi pi-search',
                        to: "/" + element.pageURL
                    }
                    menu[16].items.push(_objm);
                } else {

                    if (_roles.includes(19) && element.pageURL === "showPurchase") {
                        if (loginObj.id === 3717) {
                            let _objb = {
                                path: "/" + element.pageURL,
                                parent: 'Modules',
                                label: element.pageName
                            }
                            breadcrumb.push(_objb);
                            let _objm = {
                                label: element.pageName,
                                icon: 'pi pi-fw pi-circle',
                                to: "/" + element.pageURL
                            }
                            menu[10].items.push(_objm);
                        }
                    } else {
                        let _objb = {
                            path: "/" + element.pageURL,
                            parent: 'Modules',
                            label: element.pageName
                        }
                        breadcrumb.push(_objb);
                        let _objm = {
                            label: element.pageName,
                            icon: 'pi pi-fw pi-circle',
                            to: "/" + element.pageURL
                        }
                        menu[10].items.push(_objm);
                    }
                }
            }
        }

    });

    let _objb = {
        path: "/" + "userList",
        parent: 'Modules',
        label: "My Details"
    }
    breadcrumb.push(_objb);
    let _objm = {
        label: "My Details",
        icon: 'pi pi-fw pi-circle',
        to: "/" + "userList"
    }
    menu[10].items.push(_objm);

    let meta = breadcrumb.find((obj) => {
        return obj.path === location.pathname;
    });

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    };

    const changeMenuTheme = (name, logoColor, componentTheme) => {
        onMenuThemeChange(name);
        changeStyleSheetUrl('theme-css', componentTheme, 2);
        setComponentTheme(componentTheme);

        const appLogoLink = document.getElementById('app-logo');
        const appLogoUrl = `assets/layout/images/logo-${logoColor === 'dark' ? 'dark' : 'white'}.svg`;
        const horizontalLogoLink = document.getElementById('logo-horizontal');
        const horizontalLogoUrl = `assets/layout/images/logo-${logoColor === 'dark' ? 'dark' : 'white'}.svg`;

        if (appLogoLink) {
            appLogoLink.src = appLogoUrl;
        }
        if (horizontalLogoLink) {
            horizontalLogoLink.src = horizontalLogoUrl;
        }
        setLogoColor(logoColor);
    };

    const changeComponentTheme = (theme) => {
        setComponentTheme(theme);
        changeStyleSheetUrl('theme-css', theme, 3);
    };

    const changeColorScheme = (e) => {
        setColorScheme(e.value);

        const scheme = e.value;
        changeStyleSheetUrl('layout-css', 'layout-' + scheme + '.css', 1);
        changeStyleSheetUrl('theme-css', 'theme-' + scheme + '.css', 1);

        changeLogo(scheme);
    };

    const changeStyleSheetUrl = (id, value, from) => {
        const element = document.getElementById(id);
        const urlTokens = element.getAttribute('href').split('/');

        if (from === 1) {
            // which function invoked this function
            urlTokens[urlTokens.length - 1] = value;
        } else if (from === 2) {
            // which function invoked this function
            if (value !== null) {
                urlTokens[urlTokens.length - 2] = value;
            }
        } else if (from === 3) {
            // which function invoked this function
            urlTokens[urlTokens.length - 2] = value;
        }

        const newURL = urlTokens.join('/');

        replaceLink(element, newURL);
    };

    const changeLogo = (scheme) => {
        const appLogoLink = document.getElementById('app-logo');
        const mobileLogoLink = document.getElementById('logo-mobile');
        const invoiceLogoLink = document.getElementById('invoice-logo');
        const footerLogoLink = document.getElementById('footer-logo');
        const horizontalLogoLink = document.getElementById('logo-horizontal');
        setLogoUrl(`assets/layout/images/logo-${scheme === 'light' ? 'dark' : 'white'}.svg`);

        if (appLogoLink) {
            appLogoLink.src = `assets/layout/images/logo-${scheme === 'light' ? logoColor : 'white'}.svg`;
        }

        if (horizontalLogoLink) {
            horizontalLogoLink.src = `assets/layout/images/logo-${scheme === 'light' ? logoColor : 'white'}.svg`;
        }

        if (mobileLogoLink) {
            mobileLogoLink.src = logoUrl;
        }

        if (invoiceLogoLink) {
            invoiceLogoLink.src = logoUrl;
        }

        if (footerLogoLink) {
            footerLogoLink.src = logoUrl;
        }
    };

    const replaceLink = (linkElement, href) => {
        if (isIE()) {
            linkElement.setAttribute('href', href);
        } else {
            const id = linkElement.getAttribute('id');
            const cloneLinkElement = linkElement.cloneNode(true);

            cloneLinkElement.setAttribute('href', href);
            cloneLinkElement.setAttribute('id', id + '-clone');

            linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

            cloneLinkElement.addEventListener('load', () => {
                linkElement.remove();
                const _linkElement = document.getElementById(id);
                _linkElement && _linkElement.remove();
                cloneLinkElement.setAttribute('id', id);
            });
        }
    };

    const isIE = () => {
        return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
    };

    const onRippleChange = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onDocumentClick = () => {
        if (!searchClick && searchActive) {
            onSearchHide();
        }

        if (!userMenuClick) {
            setTopbarUserMenuActive(false);
        }

        if (!notificationMenuClick) {
            setTopbarNotificationMenuActive(false);
        }

        if (!rightMenuClick) {
            setRightMenuActive(false);
        }

        if (!menuClick) {
            if (isSlim() || isHorizontal()) {
                setMenuActive(false);
            }

            if (overlayMenuActive || staticMenuMobileActive) {
                hideOverlayMenu();
            }

            unblockBodyScroll();
        }

        if (configActive && !configClick) {
            setConfigActive(false);
        }

        searchClick = false;
        configClick = false;
        userMenuClick = false;
        rightMenuClick = false;
        notificationMenuClick = false;
        menuClick = false;
    };

    const onMenuClick = () => {
        menuClick = true;
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;
        setTopbarUserMenuActive(false);
        setTopbarNotificationMenuActive(false);
        setRightMenuActive(false);

        if (isOverlay()) {
            setOverlayMenuActive((prevOverlayMenuActive) => !prevOverlayMenuActive);
        }

        if (isDesktop()) {
            setStaticMenuDesktopInactive((prevStaticMenuDesktopInactive) => !prevStaticMenuDesktopInactive);
        } else {
            setStaticMenuMobileActive((prevStaticMenuMobileActive) => !prevStaticMenuMobileActive);
        }

        event.preventDefault();
    };

    const onMenuitemClick = (event) => {
        if (!event.item.items) {
            hideOverlayMenu();

            if (isSlim() || isHorizontal()) {
                setMenuActive(false);
            }
        }
    };

    const onRootMenuitemClick = () => {
        setMenuActive((prevMenuActive) => !prevMenuActive);
    };

    const onMenuThemeChange = (name) => {
        setMenuTheme('layout-sidebar-' + name);
    };

    const onMenuModeChange = (e) => {
        setMenuMode(e.value);
        if (e.value === 'static') {
            setStaticMenuDesktopInactive(false);
        }
    };

    const onTopbarUserMenuButtonClick = (event) => {
        userMenuClick = true;
        setTopbarUserMenuActive((prevTopbarUserMenuActive) => !prevTopbarUserMenuActive);

        hideOverlayMenu();

        event.preventDefault();
    };

    const onTopbarNotificationMenuButtonClick = (event) => {
        notificationMenuClick = true;
        setTopbarNotificationMenuActive((prevTopbarNotificationMenuActive) => !prevTopbarNotificationMenuActive);

        hideOverlayMenu();

        event.preventDefault();
    };

    const toggleSearch = () => {
        setSearchActive((prevSearchActive) => !prevSearchActive);
        searchClick = true;
    };

    const onSearchClick = () => {
        searchClick = true;
    };

    const onSearchHide = () => {
        setSearchActive(false);
        searchClick = false;
    };

    const onRightMenuButtonClick = (event) => {
        rightMenuClick = true;
        setRightMenuActive((prevRightMenuActive) => !prevRightMenuActive);
        hideOverlayMenu();
        event.preventDefault();
    };

    const onConfigClick = () => {
        configClick = true;
    };

    const onConfigButtonClick = () => {
        setConfigActive((prevConfigActive) => !prevConfigActive);
        configClick = true;
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
        unblockBodyScroll();
    };

    const unblockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };

    const isSlim = () => {
        return menuMode === 'slim';
    };

    const isHorizontal = () => {
        return menuMode === 'horizontal';
    };

    const isOverlay = () => {
        return menuMode === 'overlay';
    };

    const isDesktop = () => {
        return window.innerWidth > 1091;
    };

    const containerClassName = classNames(
        'layout-wrapper',
        {
            'layout-overlay': menuMode === 'overlay',
            'layout-static': menuMode === 'static',
            'layout-slim': menuMode === 'slim',
            'layout-horizontal': menuMode === 'horizontal',
            'layout-sidebar-dim': colorScheme === 'dim',
            'layout-sidebar-dark': colorScheme === 'dark',
            'layout-overlay-active': overlayMenuActive,
            'layout-mobile-active': staticMenuMobileActive,
            'layout-static-inactive': staticMenuDesktopInactive && menuMode === 'static',
            'p-input-filled': inputStyle === 'filled',
            'p-ripple-disabled': !ripple
        },
        colorScheme === 'light' ? menuTheme : ''
    );

    useEffect(() => {
        if (celeb !== null && celeb.view === false) {
            setCelebration(prev => prev = false);
            setCelebrationModal(prev => prev = false);
        };
    });

    useEffect(() => {
        if (showVideo !== null && showVideo.view === false) {
            setVideoModal(prev => prev = false);
        };
    });


    return (
        <div className={containerClassName} data-theme={colorScheme} onClick={onDocumentClick}>
            <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />
            <div className="layout-content-wrapper">
                <AppTopbar
                    meta={meta}
                    topbarNotificationMenuActive={topbarNotificationMenuActive}
                    topbarUserMenuActive={topbarUserMenuActive}
                    onMenuButtonClick={onMenuButtonClick}
                    onSearchClick={toggleSearch}
                    onTopbarNotification={onTopbarNotificationMenuButtonClick}
                    onTopbarUserMenu={onTopbarUserMenuButtonClick}
                    onRightMenuClick={onRightMenuButtonClick}
                    onRightMenuButtonClick={onRightMenuButtonClick}
                    menu={menu}
                    menuMode={menuMode}
                    menuActive={menuActive}
                    staticMenuMobileActive={staticMenuMobileActive}
                    onMenuClick={onMenuClick}
                    onMenuitemClick={onMenuitemClick}
                    onRootMenuitemClick={onRootMenuitemClick}
                ></AppTopbar>

                <div className="layout-content">
                    {/* {celebration && <ConfettiExplosion particleSize={20} height={'100vh'} force={3} duration={celebration ? (1000 * 60 * 2) : 0} particleCount={2000} width={20000} />}
                    <Dialog visible={celebrationModal} style={{ width: '50vw', height: "55vh" }} header="Message from the Board Room :" modal className="p-fluid" onHide={() => {
                        setCelebration(prev => prev = false);
                        setCelebrationModal(prev => prev = false);
                        localStorage.removeItem('celeb');
                        let newCeleb = { view: false };
                        localStorage.setItem('celeb', JSON.stringify(newCeleb));
                    }} maximizable>
                        <div className='flex justify-content-evenly'>
                            <img src={celeEmogi} alt="reind" style={{ display: "block" }} width={"10%"} height={"20%"} />
                            <img src={celeEmogi} alt="reind" style={{ display: "block" }} width={"10%"} height={"20%"} />
                            <img src={celeEmogi} alt="reind" style={{ display: "block" }} width={"10%"} height={"20%"} />
                            <img src={celeEmogi} alt="reind" style={{ display: "block" }} width={"10%"} height={"20%"} />
                            <img src={celeEmogi} alt="reind" style={{ display: "block" }} width={"10%"} height={"20%"} />
                        </div>
                        <h3 className="awesome" style={{ fontWeight: "bold", display: "block" }}>Message from the Board Room,<br />
                            We are happy to announce the addition of one more domain into our TEK Group of Companies.
                            The establishment will be dealing into IPTV networking, providing television forecasts in more than 90 languages globally. The company will be operational within the next 3-4 days</h3>
                    </Dialog> */}
                    {/* <Dialog visible={videoModal} style={{ width: '70vw' }} header="" modal className="p-fluid" onHide={() => {
                        setVideoModal(prev => prev = false);
                        localStorage.removeItem('showVideo');
                        let newShowVideo = { view: false };
                        localStorage.setItem('showVideo', JSON.stringify(newShowVideo));
                    }} maximizable>
                        <div className="flex">
                            <video width="100%" height="500" controls autoPlay={true}>
                                <source src={JobvrittaVideo} type="video/mp4" />
                            </video></div>
                    </Dialog> */}
                    {/* <MarqueeView className="m-0" /> */}
                    {location.pathname !== "/email" && <TopView />}
                    <div className="layout-breadcrumb viewname" style={{ textTransform: 'uppercase' }}>
                        <AppBreadcrumb meta={meta} />
                    </div>
                    <Routes>
                        <Route path='/' element={<VideoMast />} />
                        <Route path="/profile" element={<UserProfile />} />

                        {/* <Route path='/invoices' element={<Invoices />} /> */}
                        {/* <Route path='remitance' element={<Remitance />} /> */}
                        <Route path='/activeClientPerformance' element={<WorkInProgressReports />} />
                        <Route path='/subvendorTimeSheetReport' element={<SubvendorTimeSheetReport />} />
                        <Route path='/activeTimeSheetReport' element={<ActiveTimeSheetReport />} />
                        <Route path='/process' element={<Process />} />

                        {pages.has("email") && <Route path='/email' element={<Inbox />} />}
                        {/* {hasPermission("Dashboard") && <Route path="/dashboard" element={<Dashboard hasPermission={hasPermission} />} />} */}
                        {pages.has("dashboard") && <Route path="/dashboard" element={<Dashboard is_Create={pages.get("dashboard").is_Create} is_View={pages.get("dashboard").is_View} is_Update={pages.get("dashboard").is_Update} is_Export={pages.get("dashboard").is_Export} />} />}

                        {pages.has("branchdashboard") && <Route path="/branchdashboard" element={<Branch is_Create={pages.get("branchdashboard").is_Create} is_View={pages.get("branchdashboard").is_View} is_Update={pages.get("branchdashboard").is_Update} is_Export={pages.get("branchdashboard").is_Export} />} />}
                        {pages.has("companydashboard") && <Route path="/companydashboard" element={<Company is_Create={pages.get("companydashboard").is_Create} is_View={pages.get("companydashboard").is_View} is_Update={pages.get("companydashboard").is_Update} is_Export={pages.get("companydashboard").is_Export} />} />}
                        {pages.has("teamManagement") && <Route path="/teamManagement" element={<TeamManagement is_Create={pages.get("teamManagement").is_Create} is_View={pages.get("teamManagement").is_View} is_Update={pages.get("teamManagement").is_Update} is_Export={pages.get("teamManagement").is_Export} />} />}

                        {pages.has("users") && <Route path="/users" element={<UserMast is_Create={pages.get("users").is_Create} is_View={pages.get("users").is_View} is_Update={pages.get("users").is_Update} is_Export={pages.get("users").is_Export} />} />}
                        {pages.has("clientLead") && <Route path="/clientLead" element={<ClientLead is_Create={pages.get("clientLead").is_Create} is_View={pages.get("clientLead").is_View} is_Update={pages.get("clientLead").is_Update} is_Export={pages.get("clientLead").is_Export} />} />}
                        {pages.has("company") && <Route path="/company" element={<CompanyMast is_Create={pages.get("company").is_Create} is_View={pages.get("company").is_View} is_Update={pages.get("company").is_Update} is_Export={pages.get("company").is_Export} />} />}
                        {pages.has("branch") && <Route path="/branch" element={<BranchMast is_Create={pages.get("branch").is_Create} is_View={pages.get("branch").is_View} is_Update={pages.get("branch").is_Update} is_Export={pages.get("branch").is_Export} />} />}
                        {pages.has("benchConsultant") && <Route path="/benchConsultant" element={<BenchConsultant is_Create={pages.get("benchConsultant").is_Create} is_View={pages.get("benchConsultant").is_View} is_Update={pages.get("benchConsultant").is_Update} is_Export={pages.get("benchConsultant").is_Export} />} />}
                        {pages.has("ticket") && <Route path="/ticket" element={<TicketMast is_Create={pages.get("ticket").is_Create} is_View={pages.get("ticket").is_View} is_Update={pages.get("ticket").is_Update} is_Export={pages.get("ticket").is_Export} />} />}
                        {pages.has("ipConfig") && <Route path="/ipConfig" element={<IpConfig is_Create={pages.get("ipConfig").is_Create} is_View={pages.get("ipConfig").is_View} is_Update={pages.get("ipConfig").is_Update} is_Export={pages.get("ipConfig").is_Export} />} />}
                        {pages.has("clientContactPerson") && <Route path="/clientContactPerson" element={<ClientContactPerson is_Create={pages.get("clientContactPerson").is_Create} is_View={pages.get("clientContactPerson").is_View} is_Update={pages.get("clientContactPerson").is_Update} is_Export={pages.get("clientContactPerson").is_Export} />} />}
                        {pages.has("clientCompany") && <Route path="/clientCompany" element={<VendorCompanyMast is_Create={pages.get("clientCompany").is_Create} is_View={pages.get("clientCompany").is_View} is_Update={pages.get("clientCompany").is_Update} is_Export={pages.get("clientCompany").is_Export} />} />}

                        {pages.has("salesMyRequirement") && <Route path="/salesMyRequirement" element={<SalesRequirementMast tab={2} is_Create={pages.get("salesMyRequirement").is_Create} is_View={pages.get("salesMyRequirement").is_View} is_Update={pages.get("salesMyRequirement").is_Update} is_Export={pages.get("salesMyRequirement").is_Export} />} />}
                        {pages.has("salesAllRequirement") && <Route path="/salesAllRequirement" element={<SalesRequirementMast tab={1} is_Create={pages.get("salesAllRequirement").is_Create} is_View={pages.get("salesAllRequirement").is_View} is_Update={pages.get("salesAllRequirement").is_Update} is_Export={pages.get("salesAllRequirement").is_Export} />} />}
                        {pages.has("recruiterMyRequirement") && <Route path="/recruiterMyRequirement" element={<RecruiterRequirementMast tab={2} is_Create={pages.get("recruiterMyRequirement").is_Create} is_View={pages.get("recruiterMyRequirement").is_View} is_Update={pages.get("recruiterMyRequirement").is_Update} is_Export={pages.get("recruiterMyRequirement").is_Export} />} />}
                        {pages.has("recruiterAllRequirement") && <Route path="/recruiterAllRequirement" element={<RecruiterRequirementMast tab={1} is_Create={pages.get("recruiterAllRequirement").is_Create} is_View={pages.get("recruiterAllRequirement").is_View} is_Update={pages.get("recruiterAllRequirement").is_Update} is_Export={pages.get("recruiterAllRequirement").is_Export} />} />}
                        {pages.has("publishedRequirement") && <Route path="/publishedRequirement" element={<RecruiterRequirementMast tab={4} is_Create={pages.get("publishedRequirement").is_Create} is_View={pages.get("publishedRequirement").is_View} is_Update={pages.get("publishedRequirement").is_Update} is_Export={pages.get("publishedRequirement").is_Export} />} />}
                        {(pages.has("majorTechAllocation") && loginObj.is_Assign_Major_Tek === true) && <Route path="/majorTechAllocation" element={<RecruiterRequirementMast tab={3} is_Create={pages.get("majorTechAllocation").is_Create} is_View={pages.get("majorTechAllocation").is_View} is_Update={pages.get("majorTechAllocation").is_Update} is_Export={pages.get("majorTechAllocation").is_Export} />} />}

                        {pages.has("showPipeline") && <Route path="/showPipeline" element={<PipelineMast is_Create={pages.get("showPipeline").is_Create} is_View={pages.get("showPipeline").is_View} is_Update={pages.get("showPipeline").is_Update} is_Export={pages.get("showPipeline").is_Export} />} />}
                        {pages.has("pages") && <Route path="/pages" element={<PageMast is_Create={pages.get("pages").is_Create} is_View={pages.get("pages").is_View} is_Update={pages.get("pages").is_Update} is_Export={pages.get("pages").is_Export} />} />}
                        {pages.has("roles") && <Route path="/roles" element={<RoleMast is_Create={pages.get("roles").is_Create} is_View={pages.get("roles").is_View} is_Update={pages.get("roles").is_Update} is_Export={pages.get("roles").is_Export} />} />}
                        {pages.has("eci") && <Route path="/eci" element={<ECI is_Create={pages.get("eci").is_Create} is_View={pages.get("eci").is_View} is_Update={pages.get("eci").is_Update} is_Export={pages.get("eci").is_Export} />} />}
                        {pages.has("selfClientTransfer") && <Route path="/selfClientTransfer" element={<ClientTransfer is_Create={pages.get("selfClientTransfer").is_Create} is_View={pages.get("selfClientTransfer").is_View} is_Update={pages.get("selfClientTransfer").is_Update} is_Export={pages.get("selfClientTransfer").is_Export} />} />}
                        {pages.has("signature") && <Route path="/signature" element={<SignatureMast is_Create={pages.get("signature").is_Create} is_View={pages.get("signature").is_View} is_Update={pages.get("signature").is_Update} is_Export={pages.get("signature").is_Export} />} />}

                        {pages.has("website") && <Route path="/website" element={<WebsiteTemplate is_Create={pages.get("website").is_Create} is_View={pages.get("website").is_View} is_Update={pages.get("website").is_Update} is_Export={pages.get("website").is_Export} />} />}
                        {pages.has("emailTemplate") && <Route path="/emailTemplate" element={<EmailTemplate is_Create={pages.get("emailTemplate").is_Create} is_View={pages.get("emailTemplate").is_View} is_Update={pages.get("emailTemplate").is_Update} is_Export={pages.get("emailTemplate").is_Export} />} />}
                        {pages.has("endClient") && <Route path="/endClient" element={<EndClientMast is_Create={pages.get("endClient").is_Create} is_View={pages.get("endClient").is_View} is_Update={pages.get("endClient").is_Update} is_Export={pages.get("endClient").is_Export} />} />}
                        {pages.has("industry") && <Route path="/industry" element={<IndustryMast is_Create={pages.get("industry").is_Create} is_View={pages.get("industry").is_View} is_Update={pages.get("industry").is_Update} is_Export={pages.get("industry").is_Export} />} />}
                        {pages.has("majorTek") && <Route path="/majorTek" element={<MajorTech is_Create={pages.get("majorTek").is_Create} is_View={pages.get("majorTek").is_View} is_Update={pages.get("majorTek").is_Update} is_Export={pages.get("majorTek").is_Export} />} />}
                        {pages.has("salesEfficiency") && <Route path="/salesEfficiency" element={<SalesEfficiency is_Create={pages.get("salesEfficiency").is_Create} is_View={pages.get("salesEfficiency").is_View} is_Update={pages.get("salesEfficiency").is_Update} is_Export={pages.get("salesEfficiency").is_Export} />} />}
                        {pages.has("salesReport") && <Route path="/salesReport" element={<SalesReport is_Create={pages.get("salesReport").is_Create} is_View={pages.get("salesReport").is_View} is_Update={pages.get("salesReport").is_Update} is_Export={pages.get("salesReport").is_Export} />} />}
                        {pages.has("recruiterEfficiency") && <Route path="/recruiterEfficiency" element={<RecruiterEfficiency is_Create={pages.get("recruiterEfficiency").is_Create} is_View={pages.get("recruiterEfficiency").is_View} is_Update={pages.get("recruiterEfficiency").is_Update} is_Export={pages.get("recruiterEfficiency").is_Export} />} />}
                        {pages.has("recruiterReport") && <Route path="/recruiterReport" element={<RecruiterReport is_Create={pages.get("recruiterReport").is_Create} is_View={pages.get("recruiterReport").is_View} is_Update={pages.get("recruiterReport").is_Update} is_Export={pages.get("recruiterReport").is_Export} />} />}
                        {pages.has("allocationHistory") && <Route path="/allocationHistory" element={<AllocationHistory is_Create={pages.get("allocationHistory").is_Create} is_View={pages.get("allocationHistory").is_View} is_Update={pages.get("allocationHistory").is_Update} is_Export={pages.get("allocationHistory").is_Export} />} />}
                        {pages.has("showPurchase") && <Route path="/showPurchase" element={<ShowPurchaseOrder is_Create={pages.get("showPurchase").is_Create} is_View={pages.get("showPurchase").is_View} is_Update={pages.get("showPurchase").is_Update} is_Export={pages.get("showPurchase").is_Export} />} />}
                        {pages.has("empDlts") && <Route path="/empDlts" element={<EmpDlts is_Create={pages.get("empDlts").is_Create} is_View={pages.get("empDlts").is_View} is_Update={pages.get("empDlts").is_Update} is_Export={pages.get("empDlts").is_Export} />} />}
                        {pages.has("voting") && <Route path="/voting" element={<VotingQuestions is_Create={pages.get("voting").is_Create} is_View={pages.get("voting").is_View} is_Update={pages.get("voting").is_Update} is_Export={pages.get("voting").is_Export} />} />}
                        {pages.has("places") && <Route path="/places" element={<Places is_Create={pages.get("places").is_Create} is_View={pages.get("places").is_View} is_Update={pages.get("places").is_Update} is_Export={pages.get("places").is_Export} />} />}

                        {pages.has("employee") && <Route path="/employee" element={<Employee is_Create={pages.get("employee").is_Create} is_View={pages.get("employee").is_View} is_Update={pages.get("employee").is_Update} is_Export={pages.get("employee").is_Export} />} />}
                        {pages.has("source") && <Route path="/source" element={<Source is_Create={pages.get("source").is_Create} is_View={pages.get("source").is_View} is_Update={pages.get("source").is_Update} is_Export={pages.get("source").is_Export} />} />}
                        {pages.has("designation") && <Route path="/designation" element={<Designation is_Create={pages.get("designation").is_Create} is_View={pages.get("designation").is_View} is_Update={pages.get("designation").is_Update} is_Export={pages.get("designation").is_Export} />} />}
                        {pages.has("visa") && <Route path="/visa" element={<Visa is_Create={pages.get("visa").is_Create} is_View={pages.get("visa").is_View} is_Update={pages.get("visa").is_Update} is_Export={pages.get("visa").is_Export} />} />}
                        {pages.has("process") && <Route path="/process" element={<Process is_Create={pages.get("process").is_Create} is_View={pages.get("process").is_View} is_Update={pages.get("process").is_Update} is_Export={pages.get("process").is_Export} />} />}
                        {pages.has("clientTransferSetting") && <Route path="/clientTransferSetting" element={<ClientTransferSetting is_Create={pages.get("clientTransferSetting").is_Create} is_View={pages.get("clientTransferSetting").is_View} is_Update={pages.get("clientTransferSetting").is_Update} is_Export={pages.get("clientTransferSetting").is_Export} />} />}
                        {pages.has("clientTransferProgressSetting") && <Route path="/clientTransferProgressSetting" element={<ClientTransferProgressSetting is_Create={pages.get("clientTransferProgressSetting").is_Create} is_View={pages.get("clientTransferProgressSetting").is_View} is_Update={pages.get("clientTransferProgressSetting").is_Update} is_Export={pages.get("clientTransferProgressSetting").is_Export} />} />}
                        {pages.has("clientCategory") && <Route path="/clientCategory" element={<AddRequirementType is_Create={pages.get("clientCategory").is_Create} is_View={pages.get("clientCategory").is_View} is_Update={pages.get("clientCategory").is_Update} is_Export={pages.get("clientCategory").is_Export} />} />}
                        {pages.has("addNotice") && <Route path="/addNotice" element={<AddNotice is_Create={pages.get("addNotice").is_Create} is_View={pages.get("addNotice").is_View} is_Update={pages.get("addNotice").is_Update} is_Export={pages.get("addNotice").is_Export} />} />}
                        {pages.has("primeVendorPerformanceReports") && <Route path="/primeVendorPerformanceReports" element={<PrimeVendorPerformanceReports is_Create={pages.get("primeVendorPerformanceReports").is_Create} is_View={pages.get("primeVendorPerformanceReports").is_View} is_Update={pages.get("primeVendorPerformanceReports").is_Update} is_Export={pages.get("primeVendorPerformanceReports").is_Export} />} />}
                        {pages.has("timesheet") && <Route path="/timesheet" element={<ShowTimesheet is_Create={pages.get("timesheet").is_Create} is_View={pages.get("timesheet").is_View} is_Update={pages.get("timesheet").is_Update} is_Export={pages.get("timesheet").is_Export} />} />}
                        {pages.has("loginHistory") && <Route path="/loginHistory" element={<LoginHistory is_Create={pages.get("loginHistory").is_Create} is_View={pages.get("loginHistory").is_View} is_Update={pages.get("loginHistory").is_Update} is_Export={pages.get("loginHistory").is_Export} />} />}
                        {pages.has("dataCorrection") && <Route path="/dataCorrection" element={<DataCorrection is_Create={pages.get("dataCorrection").is_Create} is_View={pages.get("dataCorrection").is_View} is_Update={pages.get("dataCorrection").is_Update} is_Export={pages.get("dataCorrection").is_Export} />} />}
                        {pages.has("subVendorPerformanceReports") && <Route path="/subVendorPerformanceReports" element={<SubVendorPerformanceReports is_Create={pages.get("subVendorPerformanceReports").is_Create} is_View={pages.get("subVendorPerformanceReports").is_View} is_Update={pages.get("subVendorPerformanceReports").is_Update} is_Export={pages.get("subVendorPerformanceReports").is_Export} />} />}
                        {pages.has("attendanceMark") && <Route path="/attendanceMark" element={<AttendanceMark is_Create={pages.get("attendanceMark").is_Create} is_View={pages.get("attendanceMark").is_View} is_Update={pages.get("attendanceMark").is_Update} is_Export={pages.get("attendanceMark").is_Export} />} />}

                        {pages.has("salesAllocation") && <Route path="/salesAllocation" element={<SalesAllocation is_Create={pages.get("salesAllocation").is_Create} is_View={pages.get("salesAllocation").is_View} is_Update={pages.get("salesAllocation").is_Update} is_Export={pages.get("salesAllocation").is_Export} />} />}
                        {pages.has("nonPerformingVendor") && <Route path="/nonPerformingVendor" element={<NonPerformingVendor is_Create={pages.get("nonPerformingVendor").is_Create} is_View={pages.get("nonPerformingVendor").is_View} is_Update={pages.get("nonPerformingVendor").is_Update} is_Export={pages.get("nonPerformingVendor").is_Export} />} />}
                        {pages.has("nonPerformingPvAllocation") && <Route path="/nonPerformingPvAllocation" element={<NonPerformingPvAllocation is_Create={pages.get("nonPerformingPvAllocation").is_Create} is_View={pages.get("nonPerformingPvAllocation").is_View} is_Update={pages.get("nonPerformingPvAllocation").is_Update} is_Export={pages.get("nonPerformingPvAllocation").is_Export} />} />}
                        {pages.has("pocTransferReq") && <Route path="/pocTransferReq" element={<PocTransferReq is_Create={pages.get("pocTransferReq").is_Create} is_View={pages.get("pocTransferReq").is_View} is_Update={pages.get("pocTransferReq").is_Update} is_Export={pages.get("pocTransferReq").is_Export} />} />}
                        {pages.has("target") && <Route path="/target" element={<TargetTemplate is_Create={pages.get("target").is_Create} is_View={pages.get("target").is_View} is_Update={pages.get("target").is_Update} is_Export={pages.get("target").is_Export} />} />}
                        {(pages.has("skillTeamManagement") || (loginObj.is_Team_Lead === true && ((_roles[0] === 3 || _roles[0] === 21) && _roles.length === 1))) && <Route path="/skillTeamManagement" element={<SkillTeamManagement is_Create={(loginObj.is_Team_Lead === true && ((_roles[0] === 3 || _roles[0] === 21) && _roles.length === 1)) ? false : pages.get("skillTeamManagement").is_Create} is_View={(loginObj.is_Team_Lead === true && ((_roles[0] === 3 || _roles[0] === 21) && _roles.length === 1)) ? true : pages.get("skillTeamManagement").is_View} is_Update={(loginObj.is_Team_Lead === true && ((_roles[0] === 3 || _roles[0] === 21) && _roles.length === 1)) ? false : pages.get("skillTeamManagement").is_Update} is_Export={(loginObj.is_Team_Lead === true && ((_roles[0] === 3 || _roles[0] === 21) && _roles.length === 1)) ? false : pages.get("skillTeamManagement").is_Export} is_Delete={(loginObj.is_Team_Lead === true && ((_roles[0] === 3 || _roles[0] === 21) && _roles.length === 1)) ? false : pages.get("skillTeamManagement").is_Delete} />} />}
                        {/* {(loginObj.is_Team_Lead == true) && <Route path="/skillTeamManagement" element={<SkillTeamManagement />} />} */}

                        {pages.has("targetReportSales") && <Route path="/targetReportSales" element={<TargetHistory is_Create={pages.get("targetReportSales").is_Create} is_View={pages.get("targetReportSales").is_View} is_Update={pages.get("targetReportSales").is_Update} is_Export={pages.get("targetReportSales").is_Export} />} />}
                        {pages.has("targetReportRecruiters") && <Route path="/targetReportRecruiters" element={<TargetRecruiterHistory is_Create={pages.get("targetReportRecruiters").is_Create} is_View={pages.get("targetReportRecruiters").is_View} is_Update={pages.get("targetReportRecruiters").is_Update} is_Export={pages.get("targetReportRecruiters").is_Export} />} />}
                        {pages.has("float") && <Route path="/float" element={<Float is_Create={pages.get("float").is_Create} is_View={pages.get("float").is_View} is_Update={pages.get("float").is_Update} is_Export={pages.get("float").is_Export} />} />}
                        {pages.has("skillReport") && <Route path="/skillReport" element={<SkillReport is_Create={pages.get("skillReport").is_Create} is_View={pages.get("skillReport").is_View} is_Update={pages.get("skillReport").is_Update} is_Export={pages.get("skillReport").is_Export} />} />}
                        {/* <Route path="/skillReport" element={<SkillReport />} /> */}
                        {pages.has("skillsUserReport") && <Route path="/skillsUserReport" element={<SkillsUserReport is_Create={pages.get("skillsUserReport").is_Create} is_View={pages.get("skillsUserReport").is_View} is_Update={pages.get("skillsUserReport").is_Update} is_Export={pages.get("skillsUserReport").is_Export} />} />}
                        {pages.has("skillReportUserWiseRecruiter") && <Route path="/skillReportUserWiseRecruiter" element={<SkillRecruiterWiseReport is_Create={pages.get("skillReportUserWiseRecruiter").is_Create} is_View={pages.get("skillReportUserWiseRecruiter").is_View} is_Update={pages.get("skillReportUserWiseRecruiter").is_Update} is_Export={pages.get("skillReportUserWiseRecruiter").is_Export} />} />}
                        {pages.has("skillBranchWiseReport") && <Route path="/skillBranchWiseReport" element={<SkillBranchWiseReport is_Create={pages.get("skillBranchWiseReport").is_Create} is_View={pages.get("skillBranchWiseReport").is_View} is_Update={pages.get("skillBranchWiseReport").is_Update} is_Export={pages.get("skillBranchWiseReport").is_Export} />} />}
                        {pages.has("reqForRateApprove") && <Route path="/reqForRateApprove" element={<ReqForRateApprove is_Create={pages.get("reqForRateApprove").is_Create} is_View={pages.get("reqForRateApprove").is_View} is_Update={pages.get("reqForRateApprove").is_Update} is_Export={pages.get("reqForRateApprove").is_Export} />} />}
                        {pages.has("specialConstraintApprove") && <Route path="/specialConstraintApprove" element={<SpecialConstraintApprove is_Create={pages.get("specialConstraintApprove").is_Create} is_View={pages.get("specialConstraintApprove").is_View} is_Update={pages.get("specialConstraintApprove").is_Update} is_Export={pages.get("specialConstraintApprove").is_Export} />} />}
                        {pages.has("skillMastHistory") && <Route path="/skillMastHistory" element={<SkillMastHistory is_Create={pages.get("skillMastHistory").is_Create} is_View={pages.get("skillMastHistory").is_View} is_Update={pages.get("skillMastHistory").is_Update} is_Export={pages.get("skillMastHistory").is_Export} />} />}
                        {pages.has("pipelineStatus") && <Route path="/pipelineStatus" element={<PipelineStatus is_Create={pages.get("pipelineStatus").is_Create} is_View={pages.get("pipelineStatus").is_View} is_Update={pages.get("pipelineStatus").is_Update} is_Export={pages.get("pipelineStatus").is_Export} />} />}
                        {pages.has("recruiterRejectedReqMast") && <Route path="/recruiterRejectedReqMast" element={<RecruiterRejectedReqMast is_Create={pages.get("recruiterRejectedReqMast").is_Create} is_View={pages.get("recruiterRejectedReqMast").is_View} is_Update={pages.get("recruiterRejectedReqMast").is_Update} is_Export={pages.get("recruiterRejectedReqMast").is_Export} />} />}
                        {pages.has("testingEmailSetting") && <Route path="/testingEmailSetting" element={<TestingEmailSetting is_Create={pages.get("testingEmailSetting").is_Create} is_View={pages.get("testingEmailSetting").is_View} is_Update={pages.get("testingEmailSetting").is_Update} is_Export={pages.get("testingEmailSetting").is_Export} />} />}
                        {pages.has("teamMemberList") && <Route path="/teamMemberList" element={<TeamMemberList is_Create={pages.get("teamMemberList").is_Create} is_View={pages.get("teamMemberList").is_View} is_Update={pages.get("teamMemberList").is_Update} is_Export={pages.get("teamMemberList").is_Export} />} />}
                        {pages.has("blackListStatus") && <Route path="/blackListStatus" element={<BlackListStatus is_Create={pages.get("blackListStatus").is_Create} is_View={pages.get("blackListStatus").is_View} is_Update={pages.get("blackListStatus").is_Update} is_Export={pages.get("blackListStatus").is_Export} />} />}

                        {pages.has("blackListMast") && <Route path='blackListMast' element={<BlackListMast is_Create={pages.get("blackListMast").is_Create} is_View={pages.get("blackListMast").is_View} is_Update={pages.get("blackListMast").is_Update} is_Export={pages.get("blackListMast").is_Export} />} />}
                        {pages.has("allocationList") && <Route path='allocationList' element={<AllocationList is_Create={pages.get("allocationList").is_Create} is_View={pages.get("allocationList").is_View} is_Update={pages.get("allocationList").is_Update} is_Export={pages.get("allocationList").is_Export} />} />}
                        {pages.has("gallery") && <Route path='gallery' element={<Gallery is_Create={pages.get("gallery").is_Create} is_View={pages.get("gallery").is_View} is_Update={pages.get("gallery").is_Update} is_Export={pages.get("gallery").is_Export} />} />}
                        {pages.has("videoMast") && <Route path='videoMast' element={<VideoMast is_Create={pages.get("videoMast").is_Create} is_View={pages.get("videoMast").is_View} is_Update={pages.get("videoMast").is_Update} is_Export={pages.get("videoMast").is_Export} />} />}

                        {pages.has("outLookEmails") && <Route path="outLookEmails" element={<OutLookEmails is_Create={pages.get("outLookEmails").is_Create} is_View={pages.get("outLookEmails").is_View} is_Update={pages.get("outLookEmails").is_Update} is_Export={pages.get("outLookEmails").is_Export} />} />}
                        {pages.has("findResumes") && <Route path="findResumes" element={<FindResumes is_Create={pages.get("findResumes").is_Create} is_View={pages.get("findResumes").is_View} is_Update={pages.get("findResumes").is_Update} is_Export={pages.get("findResumes").is_Export} />} />}
                        {/* <Route path="findResumes" element={<FindResumes />} /> */}
                        {pages.has("invoiceTracking") && <Route path="invoiceTracking" element={<InvoiceTracking is_Create={pages.get("invoiceTracking").is_Create} is_View={pages.get("invoiceTracking").is_View} is_Update={pages.get("invoiceTracking").is_Update} is_Export={pages.get("invoiceTracking").is_Export} />} />}
                        {/* <Route path="invoiceTracking" element={<InvoiceTracking />} /> */}
                        {pages.has("requirementFloat") && <Route path="/requirementFloat" element={<RequirementFloat is_Create={pages.get("requirementFloat").is_Create} is_View={pages.get("requirementFloat").is_View} is_Update={pages.get("requirementFloat").is_Update} is_Export={pages.get("requirementFloat").is_Export} />} />}
                        {pages.has("allPrimeVendorPerformanceReports") && <Route path="/allPrimeVendorPerformanceReports" element={<AllPrimeVendorPerformanceReports is_Create={pages.get("allPrimeVendorPerformanceReports").is_Create} is_View={pages.get("allPrimeVendorPerformanceReports").is_View} is_Update={pages.get("allPrimeVendorPerformanceReports").is_Update} is_Export={pages.get("allPrimeVendorPerformanceReports").is_Export} />} />}
                        {pages.has("allSubVendorPerformanceReports") && <Route path="/allSubVendorPerformanceReports" element={<AllSubVendorPerformanceReports is_Create={pages.get("allSubVendorPerformanceReports").is_Create} is_View={pages.get("allSubVendorPerformanceReports").is_View} is_Update={pages.get("allSubVendorPerformanceReports").is_Update} is_Export={pages.get("allSubVendorPerformanceReports").is_Export} />} />}
                        {pages.has("imageGallery") && <Route path='imageGallery' element={<ImageGallery is_Create={pages.get("imageGallery").is_Create} is_View={pages.get("imageGallery").is_View} is_Update={pages.get("imageGallery").is_Update} is_Export={pages.get("imageGallery").is_Export} />} />}
                        {pages.has("benchRequirement") && <Route path="/benchRequirement" element={<BenchRequirement is_Create={pages.get("benchRequirement").is_Create} is_View={pages.get("benchRequirement").is_View} is_Update={pages.get("benchRequirement").is_Update} is_Export={pages.get("benchRequirement").is_Export} />} />}
                        {pages.has("pO_Incentive_Distribution") && <Route path="/pO_Incentive_Distribution" element={<PO_Incentive_Distribution is_Create={pages.get("pO_Incentive_Distribution").is_Create} is_View={pages.get("pO_Incentive_Distribution").is_View} is_Update={pages.get("pO_Incentive_Distribution").is_Update} is_Export={pages.get("pO_Incentive_Distribution").is_Export} />} />}
                        {pages.has("externalUserMast") && <Route path="/externalUserMast" element={<ExternalUserMast is_Create={pages.get("externalUserMast").is_Create} is_View={pages.get("externalUserMast").is_View} is_Update={pages.get("externalUserMast").is_Update} is_Export={pages.get("externalUserMast").is_Export} />} />}
                        {pages.has("remitance") && <Route path="/remitance" element={<Remitance is_Create={pages.get("remitance").is_Create} is_View={pages.get("remitance").is_View} is_Update={pages.get("remitance").is_Update} is_Export={pages.get("remitance").is_Export} />} />}
                        {pages.has("invoices") && <Route path="/invoices" element={<Invoices is_Create={pages.get("invoices").is_Create} is_View={pages.get("invoices").is_View} is_Update={pages.get("invoices").is_Update} is_Export={pages.get("invoices").is_Export} />} />}
                        {pages.has("activeClientPerformance") && <Route path="/activeClientPerformance" element={<WorkInProgressReports is_Create={pages.get("activeClientPerformance").is_Create} is_View={pages.get("activeClientPerformance").is_View} is_Update={pages.get("activeClientPerformance").is_Update} is_Export={pages.get("activeClientPerformance").is_Export} />} />}
                        {pages.has("assignment") && <Route path="/assignment" element={<Assignments is_Create={pages.get("assignment").is_Create} is_View={pages.get("assignment").is_View} is_Update={pages.get("assignment").is_Update} is_Export={pages.get("assignment").is_Export} />} />}
                        {pages.has("AssignmentMast") && <Route path="/AssignmentMast" element={<AssignmentMast is_Create={pages.get("AssignmentMast").is_Create} is_View={pages.get("AssignmentMast").is_View} is_Update={pages.get("AssignmentMast").is_Update} is_Export={pages.get("AssignmentMast").is_Export} />} />}
                        {pages.has("companyDocument") && <Route path="/companyDocument" element={<Company_DocumentMast is_Create={pages.get("companyDocument").is_Create} is_View={pages.get("companyDocument").is_View} is_Update={pages.get("companyDocument").is_Update} is_Export={pages.get("companyDocument").is_Export} />} />}
                        {pages.has("timeSheetReport") && <Route path="/timeSheetReport" element={<TimeSheetReport is_Create={pages.get("timeSheetReport").is_Create} is_View={pages.get("timeSheetReport").is_View} is_Update={pages.get("timeSheetReport").is_Update} is_Export={pages.get("timeSheetReport").is_Export} />} />}
                        {pages.has("consultantTimeSheetReport") && <Route path="/consultantTimeSheetReport" element={<ConsultantTimeSheetReport is_Create={pages.get("consultantTimeSheetReport").is_Create} is_View={pages.get("consultantTimeSheetReport").is_View} is_Update={pages.get("consultantTimeSheetReport").is_Update} is_Export={pages.get("consultantTimeSheetReport").is_Export} />} />}
                        {pages.has("subvendorTimeSheetReport") && <Route path="/subvendorTimeSheetReport" element={<SubvendorTimeSheetReport is_Create={pages.get("subvendorTimeSheetReport").is_Create} is_View={pages.get("subvendorTimeSheetReport").is_View} is_Update={pages.get("subvendorTimeSheetReport").is_Update} is_Export={pages.get("subvendorTimeSheetReport").is_Export} />} />}
                        {pages.has("callingHistory") && <Route path="/callingHistory" element={<CallingHistory is_Create={pages.get("callingHistory").is_Create} is_View={pages.get("callingHistory").is_View} is_Update={pages.get("callingHistory").is_Update} is_Export={pages.get("callingHistory").is_Export} />} />}
                        {pages.has("callingExtension") && <Route path="/callingExtension" element={<CallingExtension is_Create={pages.get("callingExtension").is_Create} is_View={pages.get("callingExtension").is_View} is_Update={pages.get("callingExtension").is_Update} is_Export={pages.get("callingExtension").is_Export} />} />}
                        {pages.has("iVRsUserList") && <Route path="/iVRsUserList" element={<IVRsUserList is_Create={pages.get("iVRsUserList").is_Create} is_View={pages.get("iVRsUserList").is_View} is_Update={pages.get("iVRsUserList").is_Update} is_Export={pages.get("iVRsUserList").is_Export} />} />}
                        {pages.has("docs") && <Route path="/docs" element={<Docs is_Create={pages.get("docs").is_Create} is_View={pages.get("docs").is_View} is_Update={pages.get("docs").is_Update} is_Export={pages.get("docs").is_Export} />} />}

                        {pages.has("subVendorInvoices") && <Route path='/subVendorInvoices' element={<SubVendorInvoices isProcess={false} />} />}
                        {pages.has("primeVendorInvoiceReport") && <Route path='/primeVendorInvoiceReport' element={<PrimeVendorInvoice is_Create={pages.get("primeVendorInvoiceReport").is_Create} is_View={pages.get("primeVendorInvoiceReport").is_View} is_Update={pages.get("primeVendorInvoiceReport").is_Update} is_Export={pages.get("primeVendorInvoiceReport").is_Export} />} />}
                        <Route path="/userList" element={<UserLeads loginID={loginObj.id} />} />
                        {pages.has("incentive") && <Route path='/incentive' element={<Incentives />} />}
                        {pages.has("consultantHotList") && <Route path="/consultantHotList" element={<ConsultantHotList />} />}
                        {pages.has("incentiveSetting") && <Route path="/incentiveSetting" element={<IncentiveSetting />} />}
                        {pages.has("pendingPaymentInvoices") && <Route path="/pendingPaymentInvoices" element={<PendingPaymentInvoices />} />}
                        {pages.has("generatedBranchImvoice") && <Route path="/generatedBranchImvoice" element={<GeneratedBranchImvoice />} />}
                        {pages.has("branchIncentive") && <Route path="/branchIncentive" element={<BranchIncentive />} />}
                        {pages.has("inActivePVReport") && <Route path="/inActivePVReport" element={<InActivePVReport />} />}
                        {pages.has("inActivePOCReport") && <Route path="/inActivePOCReport" element={<InActivePOCReport />} />}
                        {pages.has("followUpPoc") && <Route path="/followUpPoc" element={<FollowUpPoc />} />}
                        {pages.has("calculatedInvoiceIncentive") && <Route path="/calculatedInvoiceIncentive" element={<CalculatedInvoiceIncentive permissions={{}} />} />}
                        {pages.has("paymentUpdateSVInvoices") && <Route path='/paymentUpdateSVInvoices' element={<SubVendorInvoices isProcess={true} />} />}
                        {pages.has("pendingInvoicesCompanyWise") && <Route path="/pendingInvoicesCompanyWise" element={<PendingInvoicesCompanyWise />} />}
                        {(pages.has("branchInvoiceListByConsultant") || loginObj.id === 4212) && <Route path="/branchInvoiceListByConsultant" element={<BranchInvoiceListByConsultant />} />}
                        {pages.has("generateBranchInvoiceTable") && <Route path="/generateBranchInvoiceTable" element={<GenerateBranchInvoiceTable />} />}
                        {pages.has("qualityControle") && <Route path="/qualityControle" element={<QualityControle is_Create={pages.get("qualityControle").is_Create} is_View={pages.get("qualityControle").is_View} is_Update={pages.get("qualityControle").is_Update} is_Export={pages.get("qualityControle").is_Export} />} />}
                        {pages.has("releasedIncentiveList") && <Route path="/releasedIncentiveList" element={<ReleasedIncentiveList />} />}
                        {pages.has("userwiseLatency") && <Route path="/userwiseLatency" element={<UserwiseLatency />} />}
                        {pages.has("branchLatency") && <Route path="/branchLatency" element={<BranchLatency />} />}
                        {pages.has("leagalDocument") && <Route path="/leagalDocument" element={<LeagalDocument />} />}
                        {pages.has("clauseMaster") && <Route path="/clauseMaster" element={<ClauseMaster />} />}
                        {pages.has("hierarchyList") && <Route path="/hierarchyList" element={<HierarchyList />} />}
                        {pages.has("specialClauseMast") && <Route path="/specialClauseMast" element={<SpecialClauseMast />} />}
                        {pages.has("nonPerformingPvReport") && <Route path="/nonPerformingPvReport" element={<NonPerformingPvReport />} />}
                        {pages.has("resumeSearchConsultant") && <Route path="/resumeSearchConsultant" element={<ResumeSearchConsultant />} />}

                        {pages.has("activeTimeSheetReport") && <Route path="/activeTimeSheetReport" element={<ActiveTimeSheetReport />} />}
                        {pages.has("timesheetList") && <Route path="/timesheetList" element={<TimesheetList />} />}
                        {pages.has("allocateTeamMast") && <Route path="/allocateTeamMast" element={<AllocateTeamMast />} />}

                        {pages.has("trainingCategory") && <Route path="/trainingCategory" element={<TrainingCategory is_Create={pages.get("trainingCategory").is_Create} is_Update={pages.get("trainingCategory").is_Update} is_Delete={pages.get("trainingCategory").is_Delete} />} />}
                        {pages.has("trainingTopics") && <Route path="/trainingTopics" element={<TrainingTopics is_Create={pages.get("trainingTopics").is_Create} is_Update={pages.get("trainingTopics").is_Update} is_Delete={pages.get("trainingTopics").is_Delete} />} />}
                        {pages.has("trainingTrainners") && <Route path="/trainingTrainners" element={<TrainnerSelectionModule is_Create={pages.get("trainingTrainners").is_Create} is_Update={pages.get("trainingTrainners").is_Update} is_Delete={pages.get("trainingTrainners").is_Delete} />} />}
                        {pages.has("trainingForms") && <Route path="/trainingForms" element={<TrainingFormSubmission is_Create={pages.get("trainingForms").is_Create} is_Update={pages.get("trainingForms").is_Update} is_Delete={pages.get("trainingForms").is_Delete} />} />}
                        {pages.has("trainingSchedules") && <Route path="/trainingSchedules" element={<TrainingScheduler is_Create={pages.get("trainingSchedules").is_Create} is_Update={pages.get("trainingSchedules").is_Update} is_Delete={pages.get("trainingSchedules").is_Delete} />} />}
                        {pages.has("trainingQuestions") && <Route path="/trainingQuestions" element={<TrainingQuestions is_Create={pages.get("trainingQuestions")} is_Update={pages.get("trainingQuestions")} is_Delete={pages.get("trainingQuestions")} />} />}
                        {pages.has("trainingRatingForm") && <Route path="/trainingRatingForm" element={<TrainingRatingForm is_Create={pages.get("trainingRatingForm")} is_Update={pages.get("trainingRatingForm")} is_Delete={pages.get("trainingRatingForm")} />} />}
                        {pages.has("trainingRatings") && <Route path="/trainingRatings" element={<TrainingRatings />} />}
                        {pages.has("support") && (<Route path="/support" element={<Support hasPermission={hasPermission} is_Create={pages.get("support").is_Create} is_View={pages.get("support").is_View} is_Update={pages.get("support").is_Update} />} />)}

                        {pages.has("branchInvoicePercentageMatrix") && <Route path="/branchInvoicePercentageMatrix" element={<BranchInvoicePercentageMatrix is_Update={pages.get("branchInvoicePercentageMatrix").is_Update} />} />}

                        {pages.has("userCallingHistory") && <Route path="/userCallingHistory" element={<UserCallingHistory />} />}
                        {pages.has("legalDocumentsList") && <Route path="/legalDocumentsList" element={<LegalDocumentsList />} />}

                        {pages.has("timesheetSetting") && <Route path="/timesheetSetting" element={<TimesheetSetting />} />}
                        {pages.has("dateSetting") && <Route path="/dateSetting" element={<DateSetting />} />}
                        {pages.has("vendorCompanyAccounts") && <Route path="/vendorCompanyAccounts" element={<VendorCompanyAccounts />} />}
                        {pages.has("massMail") && <Route path="/massMail" element={<MassMail />} />}
                        {pages.has("massMailSetting") && <Route path="/massMailSetting" element={<MassMailSetting />} />}
                        {pages.has("massMailHistory") && <Route path="/massMailHistory" element={<MassMailHistory />} />}
                        {pages.has("reqPublishSetting") && <Route path='/reqPublishSetting' element={<ReqPublishSetting />} />}
                        {pages.has("externalSearchConsultant") && <Route path='/externalSearchConsultant' element={<ExternalSearchConsultant />} />}
                        {/* <Route path="/demoTable" element={<DemoTable />} /> */}
                        {pages.has("poRateAproval") && <Route path='/poRateAproval' element={<PoRateAproval />} />}
                        {pages.has("usAccountReports") && <Route path='/usAccountReports' element={<USAccountReport />} />}
                        {pages.has("companyGrouping") && <Route path="/companyGrouping" element={<CompanyGrouping />} />}
                        {pages.has("diceSetting") && <Route path="/diceSetting" element={<DiceSetting />} />}
                        {pages.has("monsterSetting") && <Route path="/monsterSetting" element={<MonsterSetting />} />}
                        {pages.has("branchAllocationSetting") && <Route path="/branchAllocationSetting" element={<BranchAllocationSetting />} />}
                        {pages.has("apwDocumentMast") && <Route path='/apwDocumentMast' element={<ApwDocumentMast />} />}
                        {pages.has("adminSetting") && <Route path="/adminSetting" element={<AdminSetting />} />}
                        {pages.has("primeVendorAllocation") && <Route path="/primeVendorAllocation" element={<PrimeVendorAllocation />} />}
                        {pages.has("legalTeamManagment") && <Route path="/legalTeamManagment" element={<LegalTeamManagement />} />}
                        {pages.has("legalTaskManagement") && <Route path="/legalTaskManagement" element={<LegalTaskManagement />} />}
                        {pages.has("consutantMaster") && <Route path='/consutantMaster' element={<ConsutantMaster />} />}
                        {pages.has("floatQuestionnaireMast") && <Route path="/floatQuestionnaireMast" element={<FloatQuestionnaireMast />} />}
                        {pages.has("legalTaskType") && <Route path="/legalTaskType" element={<LegalTaskType />} />}
                        {pages.has("tenderClientCategory") && <Route path="/tenderClientCategory" element={<TenderClientCategory />} />}
                        {pages.has("tenderClientMast") && <Route path="/tenderClientMast" element={<TenderClientMast />} />}
                        {pages.has("tenderClientPOC") && <Route path="/tenderClientPOC" element={<TenderClientPOC />} />}
                        {pages.has("tenderMast") && <Route path="/tenderMast" element={<TenderMast />} />}
                        {pages.has("tenderTeamManagementt") && <Route path="/tenderTeamManagementt" element={<TenderTeamManagementt />} />}
                        {pages.has("tenderworkStreamCategories") && <Route path="/tenderworkStreamCategories" element={<WorkStreamCategories />} />}
                        {pages.has("tenderworkStreamList") && <Route path="/tenderworkStreamList" element={<WorkStreamList />} />}
                        {pages.has("tenderServiceDepartmentMast") && <Route path="/tenderServiceDepartmentMast" element={<TenderServiceDepartmentMast />} />}
                        {pages.has("rfpBidTeamManagement") && <Route path="/rfpBidTeamManagement" element={<RPFBidTeamManagement />} />}
                        {pages.has("rfpProposalTeamManagement") && <Route path="/rfpProposalTeamManagement" element={<RFPProposalTeamManagement />} />}
                        {pages.has("rfpWorkstreamMasterDocuments") && <Route path="/rfpWorkstreamMasterDocuments" element={<RFPWorkstreamMasterDocuments />} />}
                        {pages.has("pocDepartmentMast") && <Route path="/pocDepartmentMast" element={<RFPPOCDepartmentMast />} />}
                        {pages.has("revenueReportUserWise") && <Route path="/revenueReportUserWise" element={<RevenueReportUserWise />} />}
                        {pages.has("revenueReportBranchWise") && <Route path="/revenueReportBranchWise" element={<RevenueReportBranchWise />} />}
                        {pages.has("revenueReportUserWise") && <Route path="/revenueReportUserWise" element={<RevenueReportUserWise />} />}
                        {pages.has("revenueReportBranchWise") && <Route path="/revenueReportBranchWise" element={<RevenueReportBranchWise />} />}
                        {pages.has("revenueReportSalesHead") && <Route path="/revenueReportSalesHead" element={<RevenueReportSalesHead />} />}
                        {pages.has("revenueReportRecruiterHead") && <Route path="/revenueReportRecruiterHead" element={<RevenueReportRecruiterHead />} />}
                        {pages.has("createdTimesheetsReport") && <Route path='/createdTimesheetsReport' element={<US_Account_Created_Report />} />}
                        {pages.has("escalationStatusMaster") && <Route path="/escalationStatusMaster" element={<StatusMaster />} />}
                        {pages.has("escalationTypeMaster") && <Route path="/escalationTypeMaster" element={<TypeMaster />} />}
                        {pages.has("escalationMaster") && <Route path="/escalationMaster" element={<EscalationMaster />} />}
                        {pages.has("leadScrappingJobs") && <Route path="/leadScrappingJobs" element={<LeadScrappingJobs />} />}
                        {pages.has("leadScrappingSetting") && <Route path="/leadScrappingSetting" element={<LeadScrappingSetting />} />}

                        {/* <Route path="/demo" element={<Demo />} /> */}

                        <Route path="*" element={<Navigate to='/' />} />
                    </Routes>
                </div>

                <AppFooter />
            </div>

            {/* <AppRightMenu rightMenuActive={rightMenuActive} onRightMenuClick={onRightMenuClick}></AppRightMenu> */}

            <AppConfig
                configActive={configActive}
                menuMode={menuMode}
                onMenuModeChange={onMenuModeChange}
                colorScheme={colorScheme}
                changeColorScheme={changeColorScheme}
                menuTheme={menuTheme}
                changeMenuTheme={changeMenuTheme}
                componentTheme={componentTheme}
                changeComponentTheme={changeComponentTheme}
                onConfigClick={onConfigClick}
                onConfigButtonClick={onConfigButtonClick}
                rippleActive={ripple}
                onRippleChange={onRippleChange}
                inputStyle={inputStyle}
                onInputStyleChange={onInputStyleChange}
            ></AppConfig>

            <AppSearch searchActive={searchActive} onSearchClick={onSearchClick} onSearchHide={onSearchHide} />
        </div >
    );
};

export default App;
